import React from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import BaseContainer from '@mui/material/Container';
import ControlBar from 'components/ControlBar';
import PageWrapper from 'components/PageWrapper';
import Button from 'components/Button';
import SEO from 'components/SEO';

const PageTitle = styled(Typography)`
  font-size: 1.5rem;
  margin-bottom: 2.25rem;
  margin-top: 0;
  padding-top: 2.375rem;
  text-transform: uppercase;
`;

const Container = styled(BaseContainer)`
  margin-bottom: 3rem;

  ${(props) => props.theme.breakpoints.up('lg')} {
    max-width: 1380px;
  }
`;

const ResubscribeButton = styled(Button)`
  margin-top: 1.125rem;
`;

function UnsubscribeSuccess() {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const rawUnsubscribe = queryParams.get('unsubscribe') || '';
  const unsubscribe = rawUnsubscribe.trim();
  const unsubscribeKey = unsubscribe.toLowerCase();
  const emailCategory = unsubscribe || 'the selected category';

  const buttonMapping = {
    'luckbox tgit': 'hs-cta-trigger-button hs-cta-trigger-button-185814064281',
    'cherry picks': 'hs-cta-trigger-button hs-cta-trigger-button-194888854323',
    'cherry bomb': 'hs-cta-trigger-button hs-cta-trigger-button-195264992438',
    'tasty events and announcements': 'hs-cta-trigger-button hs-cta-trigger-button-195263968171'
  };

  return (
    <>
      <SEO title='Unsubscribe Success' noindex />
      <PageWrapper className='unsubscribe-success-page'>
        <Container className='unsubscribe-success-page'>
          <PageTitle variant='h1' $page='unsubscribe-success'>
            Unsubscribe Success
          </PageTitle>
          <ControlBar color='medium' $page='unsubscribe-success' />
          <h2>We have removed your email address from our list.</h2>
          <Typography>We're sorry to see you go. You will no longer receive emails about {emailCategory}.</Typography>
          {buttonMapping[unsubscribeKey] && (
            <ResubscribeButton
              aria-label={`Resubscribe to ${emailCategory}`}
              className={buttonMapping[unsubscribeKey]}
              color='primary'
              variant='contained'
            >
              Resubscribe
            </ResubscribeButton>
          )}
        </Container>
      </PageWrapper>
    </>
  );
}

UnsubscribeSuccess.propTypes = {};

export default React.memo(UnsubscribeSuccess);
